import { values } from "ramda";
export const selectCategorySlug = (categories, id) => {
	if (!id) return null;
	if (typeof categories.byId[id] === "undefined") return null;
	return categories.byId[id].slug;
};

export const selectCategoryBySlug = (categories, slug) => {
	if (values(categories.byId).length === 0) return {};
	return values(categories.byId).reduce(
		(acc, cat) => (cat.slug === slug ? cat : acc),
		{}
	);
};
